import { Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { createPatientText, type PatientI18n, PatientTextProvider } from "~/patient_i18n/i18n";
import { PatientLanguageBar } from "~/patient_i18n/language_bar";
import { SmsOptInForm } from "~/sms_opt_in/opt_in_form";
import type { OptInOwner } from "~/sms_opt_in/paths";
import { PublicConfirmation, PublicLocationCard } from "../_location_card";

type Props = {
  owner: OptInOwner;
  locationName: string;
  logoUrl: string | null;
  addressLines: string[] | null;
  phone: string | null;
  consentLabel: string;
  submitted: boolean;
  patientI18n: PatientI18n;
};

export default function SmsOptInShow(props: Props) {
  // The language only changes on a full page load, so the strings are read once.
  // eslint-disable-next-line solid/reactivity
  const text = createPatientText(props.patientI18n);
  const t = text.t;

  return (
    <PatientTextProvider value={text}>
      <Title>{t("sms_opt_in.page_title", { name: props.locationName })}</Title>

      <PublicLocationCard
        locationName={props.locationName}
        logoUrl={props.logoUrl}
        addressLines={props.addressLines}
        phone={props.phone}
        toolbar={<PatientLanguageBar />}
      >
        <Show
          when={!props.submitted}
          fallback={
            <PublicConfirmation title={t("sms_opt_in.signed_up_title")}>
              {t("sms_opt_in.signed_up_body")}
            </PublicConfirmation>
          }
        >
          <SmsOptInForm
            owner={props.owner}
            locationName={props.locationName}
            consentLabel={props.consentLabel}
          />
        </Show>
      </PublicLocationCard>
    </PatientTextProvider>
  );
}
